module.exports = __webpack_public_path__ + "img/play-spotify.5eaf55dd.svg";